import React, {useEffect, useRef, useState} from "react";
import Styles from './EditUserModal.module.scss'
import SelectBox from "../../../Componnets/SelectBox/SelectBox";
import SetPasswordForm from "../../../login/confirmUserVerification/SetPasswordForm";
import http from "../../../../services/api/utilities/http";

const AddUserModal = (props) => {
    const [username, setUsername] = useState('')
    const [email, setEmail] = useState('')
    const [tmpEmail, setTmpEmail] = useState('')
    const [emailVerified, setEmailVerified] = useState('')
    const [loading, setLoading] = useState(false)

    const [verificationMethod , setVerificationMethod] = useState('email')
    const [loginMethod, setLoginMethod] = useState('password')
    const [ssoIdentifier, setSsoIdentifier] = useState('')
    const [role, setRole] = useState('Select role')

    const [password, setPassword] = useState('')
    const [repeatPassword, setRepeatPassword] = useState('')
    const [passwordRequirements, setPasswordRequirements] = useState(false)

    const [allowToSubmit, setAllowToSubmit] = useState(false)

    // ✅ NEW: change password toggle + loading
    const [showChangePassword, setShowChangePassword] = useState(false)
    const [changingPassword, setChangingPassword] = useState(false)

    const roles = {
        analyzer: "cf262d26-f270-4dac-a68f-df0dbae01d61",
        viewer: "e06e43b2-3341-4508-a84b-0f64b24808bc",
    }

    useEffect(() => {
        if (props.user) {
            setUsername(props.user['username'])
            setEmail(props.user['email'])
            setTmpEmail(props.user['email'])
            setRole(props.user['role'])
            setLoginMethod((props.user['login_method'] || 'password').toLowerCase())
            setSsoIdentifier(props.user['sso_identifier'] ?? '')
        }
        setAllowToSubmit(false)
    }, [])

    const handleInput = (e) => {
        if (e.target.name === 'username') setUsername(e.target.value)
        else if (e.target.name === 'email') setEmail(e.target.value)
    }

    const handleLoginMethodChange = (method) => {
        setLoginMethod(method)

        if (method === 'sso') {
            setShowChangePassword(false)
            setPassword('')
            setRepeatPassword('')
            setPasswordRequirements(false)
        }
    }

    useEffect(() => {
        if (email === tmpEmail && email) setEmailVerified(true)
        else setEmailVerified(false)
    }, [email])

    const handleSave = () => {
        setLoading(true)
        const token = localStorage.getItem('token')

        const user = {
            username,
            email,
            role,
            verified_by: verificationMethod,
            login_method: loginMethod,
            sso_identifier: ssoIdentifier,
            password: verificationMethod === "admin" && loginMethod === "password" ? password : undefined,
            confirm_password: verificationMethod === "admin" && loginMethod === "password" ? repeatPassword : undefined,
        }

        if (props.edit) {
            delete user.verified_by
            delete user.password
            delete user.confirm_password
        }

        http[props.edit ? 'patch' : 'post'](
            'authentication/user_management/' + (props.edit ? props.user.id + '/' : ''),
            user,
        )
            .then(() => {
                props.closeEditUser()
                props.refreshList()
            })
            .catch(err => {
                if (err.response?.data?.message) {
                    alert(Object.values(err.response?.data?.message)?.map(error => error[0] + "\n"))
                }
                setLoading(false)
            })
    }

    // ✅ NEW: change password webservice (separate)
    const handleChangePassword = () => {
        // اگر SetPasswordForm خودش requirements رو true/false میده، همین کافیه
        if (!passwordRequirements) return

        setChangingPassword(true)
        // 👇 این endpoint رو با بک‌اند خودت هماهنگ کن
        http.post(
            `authentication/user_management/${props.user.id}/change_password/`,
            { password, confirm_password: repeatPassword },
        )
            .then(() => {
                alert("Password changed successfully")
                setShowChangePassword(false)
                setPassword('')
                setRepeatPassword('')
                setPasswordRequirements(false)
            })
            .catch(err => {
                if (err.response?.data?.message) {
                    alert(Object.values(err.response?.data?.message)?.map(error => error[0] + "\n"))
                } else {
                    alert("Failed to change password")
                }
            })
            .finally(() => setChangingPassword(false))
    }

    useEffect(() => {
        const checkFieldsToSubmit =
            (role.split(" ").join("").length && role !== "Select role") &&
            email.split(" ").join("").length &&
            username.split(" ").join("").length

        // ✅ نکته مهم:
        // - در add mode مثل قبل
        // - در edit mode، فقط اطلاعات کاربر برای Save کافی است
        // - پسورد فقط وقتی دخیل می‌شود که (add + admin) یا (edit + showChangePassword)
        if (!props.edit) {
            // add mode
            if (verificationMethod === "admin" && loginMethod === "password") {
                ((passwordRequirements) && checkFieldsToSubmit) ? setAllowToSubmit(true) : setAllowToSubmit(false)
            } else {
                checkFieldsToSubmit ? setAllowToSubmit(true) : setAllowToSubmit(false)
            }
        } else {
            // edit mode
            checkFieldsToSubmit ? setAllowToSubmit(true) : setAllowToSubmit(false)
        }
    }, [passwordRequirements, role, email, username, verificationMethod, loginMethod, props.edit])

    const passwordArea = useRef(null)

    return (
        <div className={`d-flex justify-content-center align-items-center ${Styles.parentModal}`}>
            <div className={`${Styles.modal} ${emailVerified ? ' ' : Styles.notVerifiedModal}`}>
                <div className={`d-flex justify-content-between mb-40 ${Styles.nav}`}>
                    <div className="d-flex">
                        <svg className="pointer" onClick={props.closeEditUser} width="24" height="24"
                             viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <path d="M11.3002 12.2513L20.2502 12.2513" stroke="#0A195C" strokeWidth="1.5"
                                  strokeLinecap="round" strokeLinejoin="round"/>
                            <path fillRule="evenodd" clipRule="evenodd"
                                  d="M11.3003 7.25031L3.36329 12.2513L11.3003 17.2523L11.3003 7.25031Z" stroke="#0A195C"
                                  strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
                        </svg>
                        <p className="f20 fw500">{props.edit ? 'Edit User' : 'Add User'}</p>
                    </div>
                    <svg className="pointer" onClick={props.closeEditUser} width="25" height="24"
                         viewBox="0 0 25 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <line x1="0.75" y1="-0.75" x2="19.4657" y2="-0.75"
                              transform="matrix(-0.721387 0.692532 -0.721387 -0.692532 19.7917 5)" stroke="#060F36"
                              strokeWidth="1.5" strokeLinecap="round"/>
                        <path d="M6.18054 5.93333L19.7327 18.9434" stroke="#060F36" strokeWidth="1.5"
                              strokeLinecap="round"/>
                    </svg>
                </div>

                <div className={Styles.mainContentContainer}>
                    <div className="input-wrapper">
                        <label className="fw700 f14">Username</label>
                        <input name="username" value={username} onChange={handleInput} className="mt-3"/>
                    </div>

                    <div className="mt-32 input-wrapper">
                        <label className="fw700 f14">Role</label>
                        <SelectBox
                            dropDownValue={role}
                            style={{
                                width: 313,
                                height: 46,
                                marginTop: 16,
                                background: 'rgb(240, 242, 255)',
                                border: 'none'
                            }}
                            optionsContainerWidth={313}
                        >
                            {Object.keys(roles).map((role, key) => (
                                <div key={key} onClick={() => setRole(role)}>{role}</div>
                            ))}
                        </SelectBox>
                    </div>

                    <div className={`mt-32 input-wrapper  ${Styles.emailRow}`}>
                        <label
                            className={`fw700 f14  ${props.user?.verification_status
                                ? props.user.verification_status === "verified"
                                    ? Styles.verified
                                    : Styles.notVerified
                                : undefined}`}
                        >
                            Email
                        </label>
                        <input name="email" value={email} onChange={handleInput} className="mt-3"/>
                        <p className={Styles.emailNotif}>Editing email would need verification again</p>
                    </div>

                    <div className={`mt-32 ${Styles.loginMethodSection}`}>
                        <label className="fw700 f14">Login method</label>
                        <div className={Styles.loginMethodOptions} role="radiogroup" aria-label="Login method">
                            <button
                                type="button"
                                role="radio"
                                aria-checked={loginMethod === 'sso'}
                                className={loginMethod === 'sso' ? Styles.loginMethodActive : ''}
                                onClick={() => handleLoginMethodChange('sso')}
                            >
                                SSO
                            </button>
                            <button
                                type="button"
                                role="radio"
                                aria-checked={loginMethod === 'password'}
                                className={loginMethod === 'password' ? Styles.loginMethodActive : ''}
                                onClick={() => handleLoginMethodChange('password')}
                            >
                                Password
                            </button>
                        </div>
                        <p className={Styles.loginMethodHint}>
                            {loginMethod === 'sso'
                                ? props.edit
                                    ? 'This user will sign in with SSO. Password management is disabled.'
                                    : 'This user will sign in with SSO. A random password will be generated by the server.'
                                : 'This user will sign in with a password.'}
                        </p>
                    </div>

                    {loginMethod === 'sso' && <div className="mt-32 input-wrapper">
                        <label htmlFor="sso_identifier" className="fw700 f14">SSO identifier</label>
                        <input
                            id="sso_identifier"
                            name="sso_identifier"
                            type="text"
                            value={ssoIdentifier}
                            onChange={(e) => setSsoIdentifier(e.target.value)}
                            className="mt-3"
                        />
                    </div>}

                    {/* add user verification block (unchanged) */}
                    {!props.edit && (
                        <div className={emailVerified ? Styles.fadeOut : Styles.fadeIn}>
                            <div style={{width:296}} className={`d-flex justify-content-between ${Styles.SwitchBtn}`}>
                                <div style={verificationMethod === 'admin' ? {left : 146 , width: 146 }: {width:146}} className={Styles.ActiveBtn}></div>

                                <div
                                    onClick={() => setVerificationMethod('email')}
                                    className={`d-flex align-items-center ${Styles.item} ${verificationMethod === 'email' ? Styles.active : ''}`}
                                >
                                    <span>By Email</span>
                                </div>

                                <div
                                    onClick={() => {
                                        setVerificationMethod('admin')
                                        setTimeout(() => passwordArea.current?.scrollIntoView({ behavior: "smooth" }), 50)
                                    }}
                                    className={`d-flex align-items-center ${Styles.item} ${verificationMethod === 'admin' ? Styles.active : ''}`}
                                    style={{marginRight:26}}
                                >
                                    <span>By Admin</span>
                                </div>
                            </div>

                            {verificationMethod === 'email' ? (
                                <>
                                    <p className="f12 fw400 gray mt-2">User needs to click on the sent link</p>
                                    <p className="f14 fw700 main-purple ">Send Verification Email</p>
                                </>
                            ) : loginMethod === 'password' ? (
                                <div ref={passwordArea} className={'pt-3'}>
                                    <p className="f12 fw400 gray">Admin can verify a user without sending emails</p>
                                    <SetPasswordForm
                                        enteredPassword={(val) => setPassword(val)}
                                        enteredRepeatPassword={(val) => setRepeatPassword(val)}
                                        passwordRequirements={(val) => setPasswordRequirements(val)}
                                        title={"Set Password for user"}
                                        showSaveButton={false}
                                    />
                                </div>
                            ) : (
                                <p className={`f12 fw400 gray ${Styles.ssoPasswordNotice}`}>
                                    Password fields are not required for SSO users.
                                </p>
                            )}
                        </div>
                    )}

                    {/* ✅ NEW: Change password ONLY in edit mode, only when clicked */}
                    {props.edit && loginMethod === 'password' && (
                        <div className={`${Styles.securityCard} mt-32`}>
                            <div className={Styles.securityHeader}>
                                <div className={Styles.securityTitleRow}>
                                    <div className={Styles.securityIcon}>
                                        {/* lock icon */}
                                        <svg width="18" height="18" viewBox="0 0 24 24" fill="none">
                                            <path d="M7 10V8a5 5 0 0 1 10 0v2" stroke="currentColor" strokeWidth="1.5"
                                                  strokeLinecap="round"/>
                                            <path
                                                d="M7.5 10h9A3.5 3.5 0 0 1 20 13.5v5A3.5 3.5 0 0 1 16.5 22h-9A3.5 3.5 0 0 1 4 18.5v-5A3.5 3.5 0 0 1 7.5 10Z"
                                                stroke="currentColor" strokeWidth="1.5"/>
                                            <path d="M12 14v4" stroke="currentColor" strokeWidth="1.5"
                                                  strokeLinecap="round"/>
                                        </svg>
                                    </div>

                                    <div>
                                        <div className={Styles.securityTitle}>Security</div>
                                    </div>
                                </div>

                                <button
                                    type="button"
                                    className={Styles.accordionBtn}
                                    onClick={() => setShowChangePassword(prev => !prev)}
                                    aria-expanded={showChangePassword}
                                >
                                    <span>{showChangePassword ? "Hide" : "Change password"}</span>
                                    <span
                                        className={[Styles.chev, showChangePassword ? Styles.chevOpen : ""].join(" ")}>
          <svg width="18" height="18" viewBox="0 0 24 24" fill="none">
            <path d="M6 9l6 6 6-6" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round"
                  strokeLinejoin="round"/>
          </svg>
        </span>
                                </button>
                            </div>
                            <div className={Styles.securitySubTitle}>
                                Change password only if needed. This won’t affect other edits.
                            </div>
                            <div
                                className={[Styles.accordion, showChangePassword ? Styles.accordionOpen : ""].join(" ")}>
                                <div className={Styles.accordionInner}>
                                    <div className={Styles.notice}>
                                        <span className={Styles.dot}></span>
                                        <span>Pick a strong password. Make sure both fields match.</span>
                                    </div>

                                    <SetPasswordForm
                                        enteredPassword={(val) => setPassword(val)}
                                        enteredRepeatPassword={(val) => setRepeatPassword(val)}
                                        passwordRequirements={(val) => setPasswordRequirements(val)}
                                        title={"Change password"}
                                        showSaveButton={false}
                                    />

                                    <div className={Styles.actionRow}>
                                        <button
                                            type="button"
                                            className={Styles.secondaryBtn}
                                            onClick={() => {
                                                setShowChangePassword(false)
                                                setPassword("")
                                                setRepeatPassword("")
                                                setPasswordRequirements(false)
                                            }}
                                        >
                                            Cancel
                                        </button>

                                        <button
                                            type="button"
                                            onClick={handleChangePassword}
                                            className={[(!passwordRequirements || changingPassword) && Styles.disabled, Styles.primaryBtn].join(" ")}
                                        >
                                            {changingPassword ? "Updating..." : "Update"}
                                        </button>
                                    </div>
                                </div>
                            </div>
                        </div>
                    )}

                    {props.edit && loginMethod === 'sso' && (
                        <div className={`${Styles.ssoSecurityCard} mt-32`}>
                            <div className={Styles.securityTitle}>SSO security</div>
                            <p>Password changes are unavailable because this user signs in through SSO.</p>
                        </div>
                    )}


                    <div>
                        <button
                            onClick={handleSave}
                            className={[(!allowToSubmit || loading) && Styles.disabled, Styles.saveButton].join(" ")}
                        >
                            {loading ? "Please wait..." : "Save"}
                        </button>
                    </div>

                </div>
            </div>
        </div>
    )
}

export default AddUserModal;
